import { z } from "zod";
export const notificationRecoveryInputSchema = z.object({
  expectedVersion: z.number().int().min(0).max(999999999), sourceToken: z.string().regex(/^[a-f0-9]{64}$/),
  mutationId: z.string().uuid(), reason: z.string().trim().min(1).max(500), evidence: z.string().trim().min(1).max(2000),
}).strict();
export const notificationRecoveryStateSchema = z.object({
  id: z.string().uuid(), appId: z.string(), status: z.string(), version: z.number().int().nonnegative(),
  attempts: z.number().int().nonnegative(), maxAttempts: z.number().int().positive(),
  eligible: z.boolean(), reason: z.string().nullable(), sourceToken: z.string().regex(/^[a-f0-9]{64}$/),
});
export const notificationRecoverySchema = z.object({
  task: notificationRecoveryStateSchema,
  history: z.object({ items: z.array(z.object({
    id: z.string().uuid(), version: z.number().int().positive(), actorId: z.string(), reason: z.string(), evidence: z.string(),
    attempts: z.number().int().nonnegative(), previousMaxAttempts: z.number().int().positive(), maxAttempts: z.number().int().positive(), createdAt: z.string().datetime(),
  })), total: z.number().int().nonnegative() }),
});
export type NotificationRecovery = z.infer<typeof notificationRecoverySchema>;
export type NotificationRecoveryInput = z.infer<typeof notificationRecoveryInputSchema>;
